import { useState } from "react";
import { Button, Form, Input } from "reactstrap";
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { replyByUserAsync, sendMessageAsync, typingMessage } from "../../../../../ReduxToolkit/Reducers/Messenger/Chat";
import { toggleVisibility } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, dynamicNumber, Image } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon";
import ContactPoll from "./ContactPoll";
import useOutside from "../../../../../Utils/useOutside";
import EmojiPicker from "emoji-picker-react";

const MessageInput = () => {
  const [messageInput, setMessageInput] = useState("");
  const dispatch = useAppDispatch();
  const { activeSection } = useAppSelector((state) => state.messenger);
  const { chats, selectedUser, currentUser } = useAppSelector((state) => state.chat);
  const time = new Date().toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
  const currentUserId = currentUser?.id;
  const selectedUserId = selectedUser?.id;
  const selectedUserName = selectedUser?.name;
  const { ref, isComponentVisible, setIsComponentVisible } = useOutside(false);

  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    dispatch(toggleVisibility("emoji"));
    setMessageInput(text);
  };

  const handleMessagePress = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setTimeout(() => {
      const element = document.querySelector(".messages.custom-scroll.active");
      if (element) element.scrollBy({ top: element.scrollHeight, behavior: "smooth" });
    }, 310);
    if (messageInput.length > 0) {
      dispatch(sendMessageAsync({ currentUserId, selectedUserId, messageInput, chats, time }));
      setMessageInput("");
      dispatch(typingMessage(true));
      setTimeout(() => {
        const replyMessage = "Hey This is " + selectedUserName + ", Sorry I'm busy right now, I will text you later";
        dispatch(replyByUserAsync({ currentUserId, selectedUserId, replyMessage, chats, time }));
      }, 2000);
    }
  };

  const selectedStickers = (stickers: string) => {
    setTimeout(() => {
      const element = document.querySelector(".messages.custom-scroll.active");
      if (element) element.scrollBy({ top: element.scrollHeight, behavior: "smooth" });
    }, 310);
    dispatch(sendMessageAsync({ currentUserId, selectedUserId, stickers, chats, time }));
    dispatch(toggleVisibility("sticker"));
  };

  return (
    <div className={"message-input"}>
      <Form className="wrap emojis-main" onSubmit={handleMessagePress}>
        <ContactPoll isEmojisVisible={isComponentVisible} setIsEmojisVisible={setIsComponentVisible} />
        <Input className="setemoj" type="text" placeholder="Write your message..." value={messageInput} onChange={(e) => setMessageInput(e.target.value)} />
        <a className="icon-btn btn-outline-primary button-effect me-2 ms-2" href={Href}>
          <SvgIcon iconId="voice" />
        </a>
        <Button color="primary" className="icon-btn p-0">
          <SvgIcon iconId="send" />
        </Button>
        <div ref={ref} className={`emojis-contain custom-scroll ${activeSection === "emoji" && isComponentVisible ? "open" : ""}`}>
          <div className="emojis-sub-contain">
            <EmojiPicker onEmojiClick={({ emoji }) => addEmoji(emoji)} className="emojis-sub-contain custom-scroll" />
          </div>
        </div>
        <div ref={ref} className={`sticker-contain ${activeSection === "sticker" && isComponentVisible ? "open" : ""}`}>
          <div className="sticker-sub-contain custom-scroll">
            <ul>
              {dynamicNumber(43).map((item, index) => (
                <li key={index}>
                  <a href={Href} onClick={() => selectedStickers(dynamicImage(`sticker/${item}.gif`))}>
                    <Image className="img-fluid" src={dynamicImage(`sticker/${item}.gif`)} alt="sticker" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default MessageInput;
